import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import {Button, Table, Tab, Responsive, Popup, Icon} from 'semantic-ui-react';
import NewExamGroup from './NewExamGroup';
import {FiltersOnStyle} from "../../Professor/ProfessorInputGrades/css";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoExamTerms = () => <p>Nema kreiranih ispitnih grupa.</p>;

export default class ExamGroups extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            groupTypeId: null,
            addGroup: false
        };
        this.removeGroup = this.removeGroup.bind(this);
        this.archiveGroup = this.archiveGroup.bind(this);
        this.getGroups = this.getGroups.bind(this);
    }

    componentDidMount() {
        this.getGroups();
        axios.get('/group-types')
            .then(res => {
                let groupTypeId = res.data.find(el => el._key === 'exam').id;
                this.setState({ groupTypeId });
            })
            .catch(err => {
                console.log('Failed to fetch group types');
            });
    }

    getGroups() {
        axios.get(`/exams/groups/${localStorage.getItem('gradedActivityId')}`)
            .then(res => {
                this.setState({ data: res.data });
            })
            .catch(err => {
                console.log('Failed to fetch groups');
            });
    }

    removeGroup(id) {
        axios.delete(`/exams/remove-group/${id}`)
            .then(res => {
                toast('Brisanje grupe je uspješno izvršeno.');
                this.getGroups();
            })
            .catch(err => {
                toast('Došlo je do greške! Brisanje grupe nije uspješno izvršeno.');
            });
    }

    archiveGroup(id) {
        axios.put(`course/groups/archive/${id}`)
            .then(res => {
                toast('Arhiviranje grupe je uspješno izvršeno.');
                this.getGroups();
            })
            .catch(err => {
                toast('Došlo je do greške! Arhiviranje grupe nije uspješno izvršeno!');
            });
    }

    render() {
        const panes = [
            {
                menuItem: 'Aktivne ispitne grupe',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    {/*<br />*/}
                    {/*{*/}
                    {/*    this.state.addGroup ? <NewExamGroup*/}
                    {/*        close={() => this.setState({ addGroup: false })}*/}
                    {/*        getGroups={this.getGroups}*/}
                    {/*    />*/}
                    {/*        : <Button*/}
                    {/*            floated="right"*/}
                    {/*            icon*/}
                    {/*            labelPosition="right"*/}
                    {/*            color="blue"*/}
                    {/*            size="small"*/}
                    {/*            style={FiltersOnStyle}*/}
                    {/*            disabled={localStorage.getItem('finalized')}*/}
                    {/*            onClick={() => this.setState({ addGroup: true })}*/}
                    {/*        ><Icon className="add" />*/}
                    {/*            Kreiranje nove ispitne grupe*/}
                    {/*        </Button>*/}
                    {/*}*/}

                    {/*<br />*/}
                    {/*<br />*/}
                    {/*<br />*/}
                    <GroupsTable
                        removeGroup={(id) => this.removeGroup(id)}
                        archiveGroup={(id) => this.archiveGroup(id)}
                        data={this.state.data.filter(el => el.courseImplementationGroup.archived !== true)}
                        groupTypeId={this.state.groupTypeId}
                    /></Tab.Pane>)
            },
            // {
            //     menuItem: 'Arhivirane ispitne grupe',
            //     render: () => (<Tab.Pane attached={false} as={Responsive}>
            //         <GroupsTable
            //             archive
            //             data={this.state.data.filter(el => el.courseImplementationGroup.archived)}
            //             groupTypeId={this.state.groupTypeId}
            //         /></Tab.Pane>)
            // }
        ];

        return (
            <div>
                {/*<Tab*/}
                {/*    panes={panes}*/}
                {/*    menu={{*/}
                {/*        secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true*/}
                {/*    }}*/}
                {/*    grid={{ paneWidth: 13, tabWidth: 3 }}*/}
                {/*/>*/}

                <GroupsTable
                    removeGroup={(id) => this.removeGroup(id)}
                    archiveGroup={(id) => this.archiveGroup(id)}
                    data={this.state.data.filter(el => el.courseImplementationGroup.archived !== true)}
                    groupTypeId={this.state.groupTypeId}
                />
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}


class GroupsTable extends React.Component {
    render() {
        return (
            <div>
                {this.props.data.length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Naziv grupe</Table.HeaderCell>
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>  {this.props.data.map((el) =>
                            (<Table.Row >
                                <Table.Cell verticalAlign="middle">
                                    {el.courseImplementationGroup.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" textAlign="center">
                                    <Popup
                                        content="Spisak studenata"
                                        position="top center"
                                        trigger={
                                            <Link to={{
                                                pathname: window.location.pathname === '/ispitni-rokovi/ispiti/detalji' ? '/ispitni-rokovi/ispiti/detalji/studenti-iz-grupe' : '/kreiranje-i-prikaz-ispita-po-predmetima/detalji/studenti-iz-grupe',
                                                state: {
                                                    courseImplementationGroupId: el.courseImplementationGroup.id,
                                                    groupTypeId: this.props.groupTypeId,
                                                    groupName: el.courseImplementationGroup.name,
                                                    active: true
                                                }
                                            }}
                                            >
                                                <Button
                                                    color="blue"
                                                    basic="true"
                                                    circular
                                                    icon="group"
                                                    size="small"
                                                    onClick={() => localStorage.setItem('groupType', this.props.groupTypeId)}/>
                                            </Link>}
                                    />
                                    <Popup
                                        content="Nastavno osoblje"
                                        position="top center"
                                        trigger={
                                            <Link to={{
                                                pathname: window.location.pathname === '/ispitni-rokovi/ispiti/detalji' ? '/ispitni-rokovi/ispiti/detalji/osoblje-iz-grupe' : '/kreiranje-i-prikaz-ispita-po-predmetima/detalji/osoblje-iz-grupe',
                                                state: {
                                                    courseImplementationGroupId: el.courseImplementationGroup.id,
                                                    courseImplementationId: el.courseImplementationGroup.courseImplementation.id,
                                                    groupName: el.courseImplementationGroup.name,
                                                    active: true
                                                }
                                            }}
                                            >
                                                <Button color="teal" basic="true" circular icon="user" size="small"></Button>
                                            </Link>}
                                    />
                                    {!this.props.archive && <Popup
                                        content="Ukloni grupu s ispita"
                                        position="top center"
                                        trigger={<Button color="red" circular icon="close" basic="true" size="small" onClick={() => this.props.removeGroup(el.id)}></Button>}
                                    />}
                                    {/*{!this.props.archive && <Popup*/}
                                    {/*    content="Arhiviraj grupu"*/}
                                    {/*    position="top center"*/}
                                    {/*    trigger={<Button color="orange" basic="true" circular icon="archive" size="small" onClick={() => this.props.archiveGroup(el.courseImplementationGroup.id)}></Button>}*/}
                                    {/*/>}*/}
                                </Table.Cell>

                            </Table.Row>))
                        }
                        </Table.Body>
                    </Table>
                    : <NoExamTerms />
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/ExamGroups.js